import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VipDinerService } from '../../services/vip-diner.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var L: any;
declare var $: any;

@Component({
  selector: 'app-vip-diner',
  templateUrl: './vip-diner.component.html',
  styleUrls: ['./vip-diner.component.css'],
})
export class VipDinerComponent implements OnInit, AfterViewInit, OnDestroy {
  token: any;
  vipDinerList: any = [];
  selectedVipDiner: any = null;
  p: any = 1;
  count: any = 0;
  total: any = 10;
  err: any;
  limit: any = 10;
  offset: any;
  vipDinerForm: FormGroup = this.initForm();
  submitted: boolean = false;
  isSubmitting: boolean = false;
  selectedImage: File | null = null;
  existingImageUrl: string | null = null;
  private map: any;
  private marker: any;
  private editMap: any;
  private editMarker: any;
  private resizeObserver: any;

  constructor(
    public router: Router,
    private toastr: ToastrService,
    private vipDinerService: VipDinerService,
    private authService: AuthService,
    private formBuilder: FormBuilder
  ) {}

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.vipDinerListing();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeMap();
      this.setupResizeObserver();
    }, 0);
  }

  // Initialize map for edit modal
  initializeEditMap(): void {
    const mapContainer = document.getElementById('editVipDinerMap');
    if (!mapContainer) {
      console.error('Edit map container not found');
      return;
    }

    // Remove existing map if any
    if (this.editMap) {
      this.editMap.remove();
    }

    this.editMap = L.map('editVipDinerMap', {
      center: [25.2048, 55.2708],
      zoom: 12,
      zoomControl: true,
      attributionControl: true,
    });

    L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Maps',
      maxZoom: 20,
    }).addTo(this.editMap);

    this.editMap.on('click', (e: any) => {
      const { lat, lng } = e.latlng;

      if (this.editMarker) {
        this.editMap.removeLayer(this.editMarker);
      }

      this.editMarker = L.marker([lat, lng]).addTo(this.editMap);

      // Update form fields
      this.vipDinerForm.patchValue({
        latitude: lat.toFixed(6),
        longitude: lng.toFixed(6),
      });
    });

    // Invalidate map size after initialization
    setTimeout(() => {
      if (this.editMap) {
        this.editMap.invalidateSize();
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.map) {
      this.map.remove();
    }
    if (this.editMap) {
      this.editMap.remove();
    }
  }

  private setupResizeObserver(): void {
    const mapContainer = document.getElementById('vipDinerMap');
    if (mapContainer) {
      this.resizeObserver = new ResizeObserver(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
        if (this.editMap) {
          this.editMap.invalidateSize();
        }
      });
      this.resizeObserver.observe(mapContainer);
    }
  }

  private initializeMap(): void {
    const mapContainer = document.getElementById('vipDinerMap');
    if (!mapContainer) {
      console.error('Map container not found');
      return;
    }

    this.map = L.map('vipDinerMap', {
      center: [25.2048, 55.2708],
      zoom: 12,
      zoomControl: true,
      attributionControl: true,
    });

    L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution: '&copy; Google Maps',
      maxZoom: 20,
    }).addTo(this.map);

    this.map.on('click', (e: any) => {
      const { lat, lng } = e.latlng;

      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.marker = L.marker([lat, lng]).addTo(this.map);

      this.vipDinerForm.patchValue({
        latitude: lat.toFixed(6),
        longitude: lng.toFixed(6),
      });
    });

    setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
  }

  searchLocation(): void {
    // Check if we're in edit modal or add modal
    const isEditModal = document
      .getElementById('editVipDinerModal')
      ?.classList.contains('show');
    const searchInputId = isEditModal ? 'editLocationSearch' : 'locationSearch';
    const searchInput = document.getElementById(
      searchInputId
    ) as HTMLInputElement;

    if (searchInput && searchInput.value) {
      const query = searchInput.value;

      fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.length > 0) {
            const { lat, lon, display_name } = data[0];

            if (isEditModal && this.editMap) {
              // Update edit map
              this.editMap.setView([lat, lon], 13);

              if (this.editMarker) {
                this.editMap.removeLayer(this.editMarker);
              }

              this.editMarker = L.marker([lat, lon]).addTo(this.editMap);
            } else if (this.map) {
              // Update add map
              this.map.setView([lat, lon], 13);

              if (this.marker) {
                this.map.removeLayer(this.marker);
              }

              this.marker = L.marker([lat, lon]).addTo(this.map);
            }

            this.vipDinerForm.patchValue({
              latitude: lat,
              longitude: lon,
            });
          }
        })
        .catch((error) => {
          console.error('Error searching location:', error);
        });
    }
  }

  private initForm(): FormGroup {
    return this.formBuilder.group({
      venue_name: ['', Validators.required],
      address: ['', Validators.required],
      neighborhood: [''],
      image: [''],
      date: ['', Validators.required],
      start_time: ['', Validators.required],
      latitude: [
        '',
        [Validators.required, Validators.min(-90), Validators.max(90)],
      ],
      longitude: [
        '',
        [Validators.required, Validators.min(-180), Validators.max(180)],
      ],
    });
  }

  get f() {
    return this.vipDinerForm.controls;
  }

  // Helper method to check if field should show error
  shouldShowError(fieldName: string): boolean {
    const control = this.vipDinerForm.get(fieldName);
    return (this.submitted || control?.touched) && control?.errors
      ? true
      : false;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedImage = file;
      this.existingImageUrl = null;
    }
  }

  resetFileInput() {
    const fileInput = document.getElementById('photoInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
    this.selectedImage = null;
    this.existingImageUrl = null;
  }

  onAddVipDinerClick() {
    this.resetForm();
    this.submitted = false; // Reset validation state
    $('#addVipDinerModal').modal('show');
  }

  resetForm() {
    this.vipDinerForm.reset();
    this.submitted = false;
    this.isSubmitting = false;
    this.selectedImage = null;
    this.existingImageUrl = null;

    // Reset map
    if (this.map) {
      this.map.setView([25.2048, 55.2708], 12);
      if (this.marker) {
        this.map.removeLayer(this.marker);
        this.marker = null;
      }
    }
  }

  onSubmit() {
    this.submitted = true;

    // Mark all form controls as touched to trigger validation display
    Object.keys(this.vipDinerForm.controls).forEach((key) => {
      const control = this.vipDinerForm.get(key);
      control?.markAsTouched();
    });

    if (this.vipDinerForm.invalid) {
      return;
    }

    this.isSubmitting = true;
    const formData = new FormData();

    // Append form values with correct field names
    const formValues = this.vipDinerForm.value;
    formData.append('venue_name', formValues.venue_name);
    formData.append('address', formValues.address);
    formData.append('neighborhood', formValues.neighborhood || '');
    formData.append('date', formValues.date);
    formData.append('start_time', formValues.start_time);
    formData.append('latitude', formValues.latitude);
    formData.append('longitude', formValues.longitude);

    // Append image if selected
    if (this.selectedImage) {
      formData.append('image', this.selectedImage);
    }

    this.token = localStorage['token'];

    this.vipDinerService
      .createVipDinerReservation(formData, this.token)
      .subscribe(
        (res: any) => {
          if (res && res.status == 201) {
            this.toastr.success(
              res.message || 'VIP Diner reservation created successfully'
            );
            $('#addVipDinerModal').modal('hide');
            this.vipDinerListing();
            this.resetForm();
          } else {
            this.toastr.error(
              res.message || 'Error creating VIP Diner reservation'
            );
          }
          this.isSubmitting = false;
        },
        (error) => {
          console.error('Error creating VIP Diner reservation:', error);
          this.toastr.error('Error creating VIP Diner reservation');
          this.isSubmitting = false;
        }
      );
  }

  vipDinerListing() {
    this.token = localStorage['token'];

    // Use the new service method to get VIP Diner reservations
    this.vipDinerService.getVipDinerReservations(this.token).subscribe(
      (res: any) => {
        if (res && res.status == 200) {
          this.vipDinerList = res.data;
          this.count = this.vipDinerList.length;
        } else if (
          res.status == 400 &&
          res.message == 'Please provide valid token'
        ) {
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
          this.err = res.data;
        } else {
          this.toastr.error(res.message || 'Error fetching VIP Diner data');
        }
      },
      (error) => {
        console.error('Error fetching VIP Diner data:', error);
        this.toastr.error('Error fetching VIP Diner data');
      }
    );
  }

  onTableDataChange(event: any) {
    this.p = event;
    this.vipDinerListing();
  }

  onEdit(id: any) {
    // Find the VIP diner from the list
    this.selectedVipDiner = this.vipDinerList.find(
      (item: any) => item.id === id
    );

    if (this.selectedVipDiner) {
      this.submitted = false; // Reset validation state
      this.populateEditForm();
      $('#editVipDinerModal').modal('show');
    } else {
      this.toastr.error('VIP Diner not found in the list');
    }
  }

  populateEditForm(): void {
    if (this.selectedVipDiner) {
      this.vipDinerForm.patchValue({
        venue_name: this.selectedVipDiner.venue_name,
        address: this.selectedVipDiner.address,
        neighborhood: this.selectedVipDiner.neighborhood || '',
        date: this.selectedVipDiner.date
          ? this.formatDateForInput(this.selectedVipDiner.date)
          : null,
        start_time: this.selectedVipDiner.start_time,
        latitude: this.selectedVipDiner.latitude,
        longitude: this.selectedVipDiner.longitude,
      });

      // Set existing image if available
      this.existingImageUrl = this.selectedVipDiner.image;

      // Initialize edit map and set coordinates
      setTimeout(() => {
        this.initializeEditMap();
        this.updateEditMapWithCoordinates(
          this.selectedVipDiner.latitude,
          this.selectedVipDiner.longitude
        );
        // Invalidate map size after modal is shown
        if (this.editMap) {
          this.editMap.invalidateSize();
        }
      }, 300); // Increased timeout to ensure modal is fully rendered
    }
  }

  updateMapWithCoordinates(lat: number, lng: number): void {
    if (this.map) {
      this.map.setView([lat, lng], 15);

      if (this.marker) {
        this.map.removeLayer(this.marker);
      }

      this.marker = L.marker([lat, lng]).addTo(this.map);
    }
  }

  updateEditMapWithCoordinates(lat: number, lng: number): void {
    if (this.editMap) {
      this.editMap.setView([lat, lng], 15);

      if (this.editMarker) {
        this.editMap.removeLayer(this.editMarker);
      }

      this.editMarker = L.marker([lat, lng]).addTo(this.editMap);
    }
  }

  formatDateForInput(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    // Use local date to avoid timezone issues
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  onUpdateSubmit(): void {
    this.submitted = true;

    // Mark all form controls as touched to trigger validation display
    Object.keys(this.vipDinerForm.controls).forEach((key) => {
      const control = this.vipDinerForm.get(key);
      control?.markAsTouched();
    });

    if (this.vipDinerForm.invalid) {
      return;
    }

    this.isSubmitting = true;

    const formData: any = new FormData();
    const formValue = this.vipDinerForm.value;
    // Add form data
    Object.keys(formValue).forEach((key) => {
      if (formValue[key] !== null && formValue[key] !== undefined) {
        formData.append(key, formValue[key]);
      }
    });

    // Add image if selected
    if (this.selectedImage) {
      console.log(this.selectedImage);
      formData.append('image', this.selectedImage);
    }

    formData.append('action', 'update');

    this.token = localStorage['token'];
    this.vipDinerService
      .updateVipDinerReservation(this.selectedVipDiner.id, formData, this.token)
      .subscribe(
        (res: any) => {
          if (res && res.status == 200) {
            this.toastr.success(
              res.message || 'VIP Diner reservation updated successfully'
            );
            $('#editVipDinerModal').modal('hide');
            this.vipDinerListing();
            this.resetForm();
          } else {
            this.toastr.error(
              res.message || 'Error updating VIP Diner reservation'
            );
          }
          this.isSubmitting = false;
        },
        (error) => {
          console.error('Error updating VIP Diner reservation:', error);
          this.toastr.error('Error updating VIP Diner reservation');
          this.isSubmitting = false;
        }
      );
  }

  onDelete(id: any) {
    if (
      confirm('Are you sure you want to delete this VIP Diner reservation?')
    ) {
      this.token = localStorage['token'];

      const formData = new FormData();
      formData.append('action', 'delete');

      // Call updateVipDinerReservation with action "delete" to delete the reservation
      this.vipDinerService
        .updateVipDinerReservation(id, formData, this.token)
        .subscribe(
          (res: any) => {
            if (res && res.status == 200) {
              this.toastr.success(
                res.message || 'VIP Diner reservation deleted successfully'
              );
              this.vipDinerListing();
            } else {
              this.toastr.error(
                res.message || 'Error deleting VIP Diner reservation'
              );
            }
          },
          (error) => {
            console.error('Error deleting VIP Diner reservation:', error);
            this.toastr.error('Error deleting VIP Diner reservation');
          }
        );
    }
  }

  onView(id: any) {
    this.router.navigate(['/vip-diner', id]);
  }
}
